<template>
  <div class="redinfo">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
      <van-cell>
        <template slot="title">
          <div class="f-15 f-w">红包</div>
          <span class="c-gray">2019-10-02</span>
        </template>
        <template slot="default">
          <div class="f-15 f-w">+100</div>
          <span class="c-gray">已过期</span>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import {  List, Row, Col,Tag,Cell} from 'vant'
export default {
  data(){
    return{
      list: [],
      page:1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.$store.commit('param/show', false)
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    onLoad() {
    },
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]: List,
    [Cell.name]:Cell
  }
}
</script>

<style lang="scss">

</style>
